import Marionette from "../../shared/marionette-mustache";
import { ReportStatusView } from "./report-status";
import { ReportStatusModel } from "../models/report-status";
import { backboneViewProperties } from "../../decorators/backbone-properties";

@backboneViewProperties({
    tagName: "ul",
    className: "report-status-list",
    childView : ReportStatusView
})
export class ReportStatuses extends Marionette.CollectionView<ReportStatusModel, ReportStatusView> {
    constructor(options?: Marionette.CollectionViewOptions<ReportStatusModel>) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/import-status/views/report-statuses.ts